import { render } from "./SdtOrders.vue?vue&type=template&id=1c9b7dac&scoped=true&ts=true"
import script from "./SdtOrders.vue?vue&type=script&lang=ts"
export * from "./SdtOrders.vue?vue&type=script&lang=ts"

import "./SdtOrders.vue?vue&type=style&index=0&id=1c9b7dac&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9b7dac"]])

export default __exports__